module.exports = __webpack_public_path__ + "img/vatandas-2.a5468b60.svg";